export default __webpack_public_path__ + "static/media/NoteIcon.116298b6.svg";